if (!customElements.get('custom-section')) {
    customElements.define(
      'custom-section',
      class CustomSection extends HTMLElement {
        connectedCallback() {
          this.initializeElements();
          this.setupGrid();
        }

        disconnectedCallback() {
          // Both are only assigned when data-show-grid is set.
          this.contentSizerCleanup?.();
          this.gridCleanup?.();
        }

        initializeElements() {
          if (!this.dataset.showGrid) return;
          this.gridContainer = this.querySelector('[data-grid-container]');
          this.gridPattern = this.querySelector('[data-grid-pattern]');
          this.contentArea = this.querySelector('[data-content-area]');
        }

        calculateAndApplyContentMinHeight() {
          if (!this.contentArea) return;

          // Build a hidden measurer cloned from content area so layout/styles match
          const measurer = this.contentArea.cloneNode(true);
          // Make sure it's not participating in layout/paint
          Object.assign(measurer.style, {
            position: 'absolute',
            visibility: 'hidden',
            pointerEvents: 'none',
            inset: 'auto',
            left: '-99999px',
            top: '0',
            width: this.contentArea.offsetWidth + 'px', // match current width
            height: 'auto',
            minHeight: '0',
            maxHeight: 'none',
            opacity: '1',
          });

          document.body.appendChild(measurer);
          const mTitle = measurer.querySelector('[data-slide-title]');
          const mSub = measurer.querySelector('[data-slide-subtitle]');
          const mCaption = measurer.querySelector('[data-button-caption]');
          const mBtnWrap = measurer.querySelector('[data-carousel-button-container]');

          const maxH = this.contentArea.scrollHeight || 0;

          this.contentArea.style.minHeight = `${maxH}px`;
          document.body.removeChild(measurer);
        }

        setupContentSizer() {
          if (!this || !this.contentArea) return;
          // Run once now, and on resize
          const debounce = (fn, wait = 150) => {
            let t;
            return (...args) => {
              clearTimeout(t);
              t = setTimeout(() => fn.apply(null, args), wait);
            };
          };

          const run = () => this.calculateAndApplyContentMinHeight();
          run();
          this._contentResizeHandler = debounce(run, 150);
          window.addEventListener('resize', this._contentResizeHandler);
          // Cleanup hook
          this.contentSizerCleanup = () => {
            window.removeEventListener('resize', this._contentResizeHandler);
          };
        }

        setupGrid() {
          if (!this.dataset.showGrid || !this.gridPattern) return;


          this.setupContentSizer();

          const calculateGridDimensions = () => {

            if (!this) return;

            const containerRect = this.getBoundingClientRect();
            const tileSize = 72;

            // Calculate the number of complete tiles that fit
            const tilesHeight = Math.floor(containerRect.height / tileSize);

            // Calculate perfect grid dimensions - add 1 for the final grid line
            const perfectHeight = tilesHeight * tileSize + 1;

            this.gridPattern.style.width = '100%';
            this.gridPattern.style.height = `${perfectHeight}px`;
            this.gridPattern.style.backgroundImage = `
          linear-gradient(to right, var(--grid-line) 1px, transparent 1px),
          linear-gradient(to bottom, var(--grid-line) 1px, transparent 1px)`;
            this.gridPattern.style.backgroundSize = `${tileSize}px ${tileSize}px`;
            this.gridPattern.style.backgroundPosition = '0 0';
            this.gridPattern.style.backgroundRepeat = 'repeat';
          };

          // Initial calculation
          calculateGridDimensions();

          // Recalculate on window resize
          const handleResize = () => calculateGridDimensions();
          window.addEventListener('resize', handleResize);

          // Store cleanup function
          this.gridCleanup = () => {
            window.removeEventListener('resize', handleResize);
          };
        }
      }
    );
  }